import React from "react";
import { Card, IconButton } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ImageIcon from '@mui/icons-material/Image';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/DataTable";

const ProductTable = ({
    products,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    onView,
    onMedia,
    onEdit,
    onDelete,
    onAddProduct
}) => {
    const columns = [
        {
            Header: "S.No.",
            accessor: "s_no",
            sortable: true,
        },
        {
            Header: "Product Name",
            accessor: "product_name",
            sortable: true,
        },
        {
            Header: "Category",
            accessor: "category_name",
            sortable: true,
        },
        {
            Header: "Price",
            accessor: "price",
            sortable: true,
        },
        {
            Header: "Stock Quantity",
            accessor: "stock_quantity",
            sortable: true,
        },
        {
            Header: "Options",
            accessor: "options",
            Cell: ({ row }) => (
                <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <IconButton color="info" onClick={() => onView(row.original)}>
                        <VisibilityIcon />
                    </IconButton>
                    <IconButton color="primary" onClick={() => onMedia(row.original)}>
                        <ImageIcon />
                    </IconButton>
                    <IconButton color="success" onClick={() => onEdit(row.original)}>
                        <EditIcon />
                    </IconButton>
                    {/* Use product_id from your model */}
                    <IconButton color="error" onClick={() => onDelete(row.original.product_id)}>
                        <DeleteIcon />
                    </IconButton>
                </div>
            )
        }
    ];

    const startIndex = page * rowsPerPage;
    const paginatedProducts = products.slice(startIndex, startIndex + rowsPerPage);
    const data = paginatedProducts.map((product, index) => ({
        s_no: startIndex + index + 1,
        ...product,
        specification: Array.isArray(product?.specification)
            ? product.specification
            : (typeof product?.specification === "string"
                ? JSON.parse(product.specification)
                : []),
    }));

    return (
        <Card>
            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h6" color="white">Product Details</MDTypography>
            </MDBox>
            <MDBox sx={{ textAlign: "right", mt: 4, mr: 4 }}>
                <MDButton color="success" onClick={onAddProduct}>Add Product</MDButton>
            </MDBox>
            <MDBox p={3}>
                <DataTable
                    table={{ columns, rows: data }}
                    isSorted={true}
                    entriesPerPage={{ defaultValue: rowsPerPage, entries: [5, 10, 15, 20, 25] }}
                    showTotalEntries={true}
                    canSearch={true}
                    noEndBorder
                    pagination={{
                        variant: "contained",
                        color: "dark",
                        page: page,
                        onPageChange: onPageChange,
                        rowsPerPage: rowsPerPage,
                        onRowsPerPageChange: onRowsPerPageChange,
                        count: products.length,
                    }}
                />
            </MDBox>
        </Card>
    );
};

export default ProductTable;
